var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntityCardLabel',_vm._b({staticClass:"entity-card-label",attrs:{"label":"Staff pick","h-align":"right"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('TheStarIcon')]},proxy:true}])},'EntityCardLabel',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }